<div class="list-for-promotion-items -layout-{{loading ? 'row' : layout}}">
    <div class="list-for-promotion-items__inner row">

        <ng-container *ngIf="loading">
            <div class="list-for-promotion-items__item col" *ngFor="let item of emptyPlaceholders; trackBy: trackBy">
                <shared-tile-for-promotion-item type="column" [loading]="true"></shared-tile-for-promotion-item>
            </div>
        </ng-container>

        <ng-container *ngIf="!loading">
            <ng-container *ngFor="let item of promotionItems | limit:limit; trackBy: trackBy; let i = index">
                <div class="list-for-promotion-items__item col">
                    <shared-tile-for-promotion-item [item]="item" [layout]="layout" [isEven]="(i+1) % 2 === 0">
                    </shared-tile-for-promotion-item>
                </div>
            </ng-container>
        </ng-container>

    </div>
</div>